import { render, staticRenderFns } from "./JSelectBatchModal.vue?vue&type=template&id=a606a2c6&scoped=true"
import script from "./JSelectBatchModal.vue?vue&type=script&lang=js"
export * from "./JSelectBatchModal.vue?vue&type=script&lang=js"
import style0 from "./JSelectBatchModal.vue?vue&type=style&index=0&id=a606a2c6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a606a2c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a606a2c6')) {
      api.createRecord('a606a2c6', component.options)
    } else {
      api.reload('a606a2c6', component.options)
    }
    module.hot.accept("./JSelectBatchModal.vue?vue&type=template&id=a606a2c6&scoped=true", function () {
      api.rerender('a606a2c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecgbiz/modal/JSelectBatchModal.vue"
export default component.exports